module.exports = __webpack_public_path__ + "img/3_164.de8cd70d.png";